if (!customElements.get('card-media-slider')) {
  customElements.define(
    'card-media-slider',
    class CardMediaSlider extends HTMLElement {
      constructor() {
        super();
        this.slides = Array.from(this.querySelectorAll('.card-media-slide'));
        this.activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (this.activeIndex < 0) this.activeIndex = 0;

        this.querySelectorAll('.card-media-arrow').forEach((button) => {
          button.addEventListener('click', this.onArrowClick.bind(this));
        });
      }

      onArrowClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const direction = parseInt(event.currentTarget.dataset.direction, 10);
        this.setActiveIndex(this.activeIndex + direction);
      }

      setActiveIndex(index) {
        const total = this.slides.length;
        this.activeIndex = ((index % total) + total) % total;

        this.slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === this.activeIndex);
        });
      }
    }
  );
}

// The full-card "go to product" link is an invisible overlay CSS positions behind the
// image so the arrows/cart icon on top of it stay clickable (see component-card-overlay.css).
// That's proven fragile across browsers/contexts, so make the image itself navigate directly
// via JS too - unambiguous regardless of any stacking/pointer-events setup.
document.addEventListener('click', (event) => {
  const media = event.target.closest('.card__media[data-product-url]');
  if (!media) return;
  if (event.target.closest('.card-media-arrow, .quick-add')) return;

  window.location.href = media.dataset.productUrl;
});
